export const STORAGE_QUICKBOOK_PREVOUS_URL = 'quickbook_previous_url';
